import Swal from 'sweetalert2';

export const validateExpenseForm = (formValues, expenseType) => {
  const parsedAmount = parseFloat(formValues.amount);

  if (isNaN(parsedAmount) || parsedAmount <= 0) {
    Swal.fire({
      icon: 'error',
      title: 'Erreur',
      text: 'Le montant doit être un nombre positif',
      confirmButtonText: 'OK'
    });
    return false;
  }

  switch (expenseType) {
    case 'hotel':
      if (!formValues.date_depart_hotel) {
        alert('Veuillez remplir la date de départ pour l\'hôtel.');
        return false;
      }
      break;
    case 'carRental':
      if (!formValues.date_fin_loc) {
        alert('Veuillez remplir la date de fin pour la location de véhicule.');
        return false;
      }
      break;
    default:
      break;
  }

  return true;
};

export const getMainDate = (formValues, expenseType) => {
  switch (expenseType) {
    case 'carRental':
      return formValues.date_fin_loc || formValues.date;
    case 'hotel':
      return formValues.date_depart_hotel || formValues.date;
    default:
      return formValues.date;
  }
}; 
